import { errorMessagesProxy } from "@/utils/helpers";

export const CYO_ERRORS = errorMessagesProxy({
  GENERIC_ERROR:
    "Sorry, there has been a problem with that request. Please try again.",
});
